/* eslint-disable @typescript-eslint/no-use-before-define */
import React, {
	ReactElement,
	useState,
	useContext,
	useEffect,
	ChangeEvent,
} from "react"
import { useFormik } from "formik"
import { Button, Box, Grid } from "@material-ui/core"
import { useHistory } from "react-router-dom"
import { BaseCFCStruct } from "../../../data/_config/shape"
import { initialValues } from "."
import { PanelsTitle } from "../../CFC"
import Spacer from "../../Spacer/Spacer"
import { routeVarReplacement, PrivateRoutes } from "../../../util/routes/routes"
import useCurrentClient from "../../../state/client/useCurrentClient"
import useStyles from "./__config/styles"
import DescriptiveNumberInput from "../../DescriptiveNumberInput"
import { useParams } from "react-router-dom"

/**
 * Create canvas form.
 *
 * @export
 * @returns {ReactElement}
 */
export default function StepCiklogramForm({
	osveziMaster,
	values,
}: {
	osveziMaster: (values: any) => void
	values: any
}): ReactElement {
	const styles = useStyles()
	const { id: canvasId } = useParams<any>()

	const [useCustomTitle, setUseCustomTitle] = useState(false)
	const history = useHistory()
	const [currentClient] = useCurrentClient()

	const {
		setFieldValue,
		handleChange,
		// values,
		handleSubmit,
	} = useFormik<BaseCFCStruct>({
		initialValues,
		onSubmit: async (formValues: BaseCFCStruct) => {},
	})

	const onPrev = async () => {
		if (currentClient?.id) {
			const id = 1
			const query = ""

			history.push(
				`${routeVarReplacement(PrivateRoutes.PlanningStep4, [
					[":id", `${id}`],
				])}?${query}`
			)
		}
	}

	const onNext = async () => {
		if (currentClient?.id) {
			const id = 1
			const query = ""

			history.push(
				`${routeVarReplacement(PrivateRoutes.PlanningStep5, [
					[":id", `${id}`],
				])}?${query}`
			)
		}
	}

	useEffect(() => {
		if (!useCustomTitle) {
			setFieldValue("canvasTitle", "")
		}
	}, [useCustomTitle, setFieldValue])

	const { canvasTitle } = values

	const [zauzetostNadzemno, setZauzetostNadzemno] = useState(0)
	const [brutoNadzemnoUkupno, setBrutoNadzemnoUkupno] = useState(0)

	return (
		<>
			<form onSubmit={handleSubmit} data-reactour="create-a-canvas">
				<PanelsTitle
					customTitle={
						"Automatsko crtanje ciklograma na osnovu broja spratova i trajanja aktivnosti (početak, kraj) "
					}
					useCustomTitle={true}
				/>
				<Spacer />
				<Spacer />
				<Box className={styles.box}>
					<Grid
						container
						spacing={1}
						// alignItems="center"
						justify="center"
						// alignContent="center"
					>
						<Grid item xs={5}>
							<>USKORO!!!</>
							{/* <DescriptiveNumberInput
								mini
								variant="outlined"
								onChange={(e: ChangeEvent<HTMLInputElement>) =>
									setZauzetostNadzemno(+e.target.value)
								}
								value={zauzetostNadzemno}
								// name="1"
								label=""
								title="Zauzetost nadzemno"
								description=""
								um=""
								disabled={true}
							/> */}
							<Spacer />
						</Grid>
					</Grid>
				</Box>
				<Spacer />
				<Box className={styles.box}>
					<Button color="primary" variant="outlined" onClick={onPrev}>
						Nazad
					</Button>
				</Box>
			</form>
		</>
	)
}
